import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter, inject} from "@angular/core";
import { NZ_MODAL_DATA, NzModalService } from "ng-zorro-antd/modal";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'view-image',
  templateUrl: "./view-image.html",
  styleUrls: ['./view-image.scss'],
})

export class ViewImageComponent implements OnInit, AfterViewInit, OnDestroy  {
    @Input('image') image: any = {};
    rotatePhoto = 1;
    readonly nzModalData: any = inject(NZ_MODAL_DATA);
    constructor(
        public modalService: NzModalService
    ) {
    }
    ngOnInit() {
        this.image = this.nzModalData.image;
    }
    ngAfterViewInit() {
        
    }
    ngOnDestroy() {
    }
    dismiss() {
        this.modalService.closeAll();
    }
    getRotate() {
        let cla = '';
        switch (this.rotatePhoto) {
            case 1:
                cla = 'rotate0';
            break;
            case 2:
                cla = 'rotate90';
            break;
            case 3:
                cla = 'rotate180';
            break;
            case 4:
                cla = 'rotate270';
            break;
        }
        return cla;
    }
    rotatePrevious() {
        if (this.rotatePhoto > 1) {
            this.rotatePhoto--;
        }
    }
    rotateNext() {
        if (this.rotatePhoto < 4) {
            this.rotatePhoto++;
        }
    }
    download() {
        window.open(this.image.url, '_blank');
    }
}
